import * as fromDatatype from '../datatype-library/index';

export interface bl_mrp_ppq_worklog_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  mrp_ppq_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  shift_date: fromDatatype.TimestampTzDatatypeInterface;
  shift_remarks: fromDatatype.VarcharDatatypeInterface;
  shift_type: fromDatatype.VarcharDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  end_time: fromDatatype.TimestampTzDatatypeInterface;
  total_qty_required: fromDatatype.NumericDatatypeInterface;
  total_qty_produced: fromDatatype.NumericDatatypeInterface;
  production_rate: fromDatatype.NumericDatatypeInterface;
  production_rate_material_uom: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  pic_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  process_type_code: fromDatatype.VarcharDatatypeInterface;
  supervisor_remarks: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mrp_ppq_worklog_Rowclass implements bl_mrp_ppq_worklog_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  mrp_ppq_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  shift_date: fromDatatype.TimestampTzDatatypeInterface;
  shift_remarks: fromDatatype.VarcharDatatypeInterface;
  shift_type: fromDatatype.VarcharDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  end_time: fromDatatype.TimestampTzDatatypeInterface;
  total_qty_required: fromDatatype.NumericDatatypeInterface;
  total_qty_produced: fromDatatype.NumericDatatypeInterface;
  production_rate: fromDatatype.NumericDatatypeInterface;
  production_rate_material_uom: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  pic_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  process_type_code: fromDatatype.VarcharDatatypeInterface;
  supervisor_remarks: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}